<span class="ds-inliner svg-icon-cover" :class="inlinerSizes"><component class="ds-inliner__body" :is="props.name" :key="props.name"></component></span>